<template>
    <ol class="breadcrumb">
        <li class="breadcrumb-item" v-for="(item, index) in list">
            <span v-if="isLast(index)" class="active" >{{ showName(item) }}</span>
            <router-link v-else :to="item">{{ showName(item) }}</router-link>
        </li>
    </ol>
</template>

<script>
  export default {
      name: 'breadcrumb',
      props: {
          list: {
              type: Array,
              required: true,
              default: () => []
          }
      },
      methods: {
          isLast (index) {
              return index === this.list.length - 1
          },
          showName (item) {
              if (item.meta && item.meta.label) {
                  item = item.meta && item.meta.label
              }
              if (item.name) {
                  item = item.name
              }
              return item
          }
      }
  }
</script>

<style>
    .breadcrumb {
        position: static;
        margin: 0;
        border-bottom: none;
    }
</style>


// WEBPACK FOOTER //
// Breadcrumb.vue?b1e3ac88